import { render } from "./crypt-transfer.vue?vue&type=template&id=b245c212&scoped=true&ts=true"
import script from "./crypt-transfer.vue?vue&type=script&lang=ts"
export * from "./crypt-transfer.vue?vue&type=script&lang=ts"

import "./crypt-transfer.vue?vue&type=style&index=0&id=b245c212&lang=less&scoped=true"
import "./crypt-transfer.vue?vue&type=style&index=1&id=b245c212&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b245c212"]])

export default __exports__